import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { Button, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ExcelExport = ({ data, fileName, onClick, isLoading }) => {
  const { t } = useTranslation();
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
    saveAs(blob, `${fileName}.xlsx`);
    onClick && onClick();
  };

  return (
    <Button 
        onClick={exportToExcel} 
        variant="contained"
        disabled={isLoading}
    >
      {isLoading &&
        <><CircularProgress color='inherit' size={14} />&nbsp;</>
      }
      {t('reports.downloadExcel')}
    </Button>
  );
}

export default ExcelExport;